import { useLiveChatModuleAvailable } from './useLiveChatModuleAvailable';
import { useOfflineModulesAvailable } from './useOfflineModulesAvailable';

export default function useBackButtonAvailable(): boolean {
  const liveChatAvailable = useLiveChatModuleAvailable();
  const offlineModulesAvailable = useOfflineModulesAvailable();

  return !liveChatAvailable || offlineModulesAvailable;
}
